<template>
  <q-card class="q-pa-md full-width text-center flex-center">
    <q-card-section>
      <h4 class="text-bold text-uppercase">Subscribe</h4>
      <p class="q-mt-md">
        Please subscribe to record to continue using Voizor.ai.
      </p>
      <p class="q-mt-md text-cation">
        If you <b>have alread paid</b>, please
        <span
          class="text-underline text-blue cursor-pointer"
          @click="() => window.location.reload()"
          >reload the page</span
        >
        to continue
      </p>

      <PrimaryButton
        v-if="isFirstPayment"
        @click="onPay(organization.id)"
        class="q-mt-lg full-width"
      >
        Subscribe
      </PrimaryButton>
      <PrimaryButton
        v-else
        label="Manage"
        class="q-mt-lg full-width"
        @click="async () => window.open(portalUrl, '_blank')"
      />
      <SecondaryButton
        @click="() => window.location.reload()"
        class="q-mt-lg full-width"
        label="Reload"
      />
    </q-card-section>
  </q-card>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import PrimaryButton from '@/components/brand/PrimaryButton.vue';
import { SendError } from '@/helpers';
import SecondaryButton from '@/components/brand/SecondaryButton.vue';
import { Sentry } from '@/vendors/Sentry';

const store = useStore();
const portalUrl = ref(null);

const props = defineProps({
  organization: {
    type: Object,
    required: true,
  },
  isFirstPayment: {
    type: Boolean,
    default: false,
  },
});

const onPay = async (organizationId) => {
  try {
    await store.dispatch('onPay', organizationId);
  } catch (err) {
    Sentry.captureException(err);
    SendError('Something went wrong please try again later');
  }
};

onBeforeMount(async () => {
  if (!props.isFirstPayment) {
    portalUrl.value = await store.dispatch('getStripePortalUrl');
  }
});
</script>
